import { Deserializable } from '../../protocols/deserializable';
import { Address } from '../dto/address';
import { EmploymentHistory } from '../dto/employment-history';

export class CreateMemberRequest implements Deserializable {
  public firstName: string = '';
  public lastName: string = '';
  public email: string = '';
  public birthDate: string = '';
  public socialInsuranceNumber: string = '';
  public primaryPhoneNumber: string | null = null;
  public primaryPhoneNumberCountryCode?: string | null = null;
  public secondaryPhoneNumber: string | null = null;
  public secondaryPhoneNumberCountryCode?: string | null = null;
  public address: Address | null = null;
  public employmentHistory: EmploymentHistory | null = null;

  public onDeserialize() {
    const Deserialize = window?.injector?.Deserialize;
    this.address = Deserialize?.instanceOf(Address, this.address);
    this.employmentHistory = Deserialize?.instanceOf(EmploymentHistory, this.employmentHistory);
  }
}
